import type { Dataset, FieldCoverage, SourceSync } from '../domain/types';
import { generateDataset } from '../fixtures/generator';
import { coverageFor, filterByRange, type AdapterQuery, type AdapterResponse, type DataAdapter } from './types';

function respond<T extends { fromUtc: string; id?: string }>(items: T[], q: AdapterQuery, sourceId: string, coverage: FieldCoverage[] = []): AdapterResponse<T> {
  const data = filterByRange(items, q);
  return {
    data,
    coverage,
    warnings: [],
    sourceRefs: [{ sourceId, recordIds: data.map((d) => (d as any).id ?? '').filter(Boolean) }],
  };
}

/** Standardadapter: deterministiske lokale fixtures. Ingen nettverk. */
export class MockAdapter implements DataAdapter {
  readonly kind = 'mock' as const;
  readonly label = 'Lokal adapter (eksempeldata)';
  readonly isSimulated = true as const;

  async getDataset(scenarioId: string): Promise<Dataset> {
    return generateDataset(scenarioId);
  }
  async getProduction(q: AdapterQuery) {
    const ds = generateDataset(q.scenarioId);
    return respond(ds.production, q, 'produksjon');
  }
  async getLineStates(q: AdapterQuery) {
    const ds = generateDataset(q.scenarioId);
    return respond(ds.lineStates, q, 'produksjon');
  }
  async getMachineIntervals(q: AdapterQuery) {
    const ds = generateDataset(q.scenarioId);
    const data = filterByRange(ds.machineIntervals, q);
    return respond(ds.machineIntervals, q, 'maskindata', coverageFor(data, filterByRange(ds.production, q)));
  }
  async getAllocations(q: AdapterQuery) {
    const ds = generateDataset(q.scenarioId);
    const data = ds.allocations.filter((a) => a.fromUtc < q.toUtc && a.toUtc > q.fromUtc);
    return { data, coverage: [], warnings: [], sourceRefs: [{ sourceId: 'demo-allokering', recordIds: [] }] };
  }
  async getCoverage(q: AdapterQuery) {
    const ds = generateDataset(q.scenarioId);
    return coverageFor(filterByRange(ds.machineIntervals, q), filterByRange(ds.production, q));
  }
  async getSourceStatus(scenarioId: string): Promise<SourceSync[]> {
    return generateDataset(scenarioId).sources;
  }
}
